import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { POST } from '../../../helpers/httphelper';

function MedicinesFilterByChanneling() {
    const [medicineAll, setMedicineAll] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const UserID = localStorage.getItem('user');
    
    const reason  = useParams();
    // get useParam value and convert to string
    const reasonString = reason.id.toString();

    console.log(reasonString);
    console.log(UserID);
    useEffect(() => {
        const pr = POST('api/medicine/filterReason', { UserID, reasonString })
            .then(res => {
                console.log(res);
                setMedicineAll(res);
            }).catch(err => {
                console.log(err);
            });

        // set isLoading to false after the data is loaded
        Promise.all([pr]).then(() => {
            setIsLoading(false);
        });
    }, [ UserID, reasonString])

    console.log(medicineAll);
  return (
    <section className="hero is-fullheight-with-navbar">
      <div className="hero-body" style={{ alignItems: 'normal' }}>
        <div className="container is-fluid">
        <div className='columns'>
                <div className='column is-12'>
                    <div className='mb-5'>
                        <h1 className="title is-1 is-light is-semibold is-spaced main-title is-justify-content-start is-flex "> 
                        {reasonString.charAt(0).toUpperCase() + (reasonString.slice(1).toLowerCase())} - Medicine
                        </h1>
                    </div>
                    <div className='columns is-multiline is-align-content-flex-start' style={{ height: '75vh', overflow: 'scroll' }}>
                        {isLoading ?
                            <div className='column is-12 has-text-centered'>
                                <div className="container mt-4">
                                    <div className="notification is-success title is-3">
                                        <b> Loading  Medicine... </b>
                                        {/* rotating loading icon from bulma */}
                                        <span className="icon is-large">
                                            <i className="fas fa-sync-alt fa-spin" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                            :
                            (medicineAll.length > 0) ? (medicineAll?.map((medicine, index) => (
                                <div key={index} className='column is-4'>
                                    <Link to={`/medicines/view/${medicine._id}`}>
                                        <div className='card' style={{ backgroundColor: '#EFEFEF', borderRadius: '25px' }}>
                                            <div className='is-flex' style={{ backgroundColor: '#7BC8FF', borderRadius: '25px 25px 0px  0px' }}>
                                                <div className='ml-4 mt-4 mb-4 title is-3'>
                                                    <i className="fa-solid fa-capsules"></i>
                                                </div>
                                                <div className='ml-5 mt-4 mb-4 title is-4'>
                                                    {medicine?.MedicineName}
                                                </div>
                                            </div>
                                            <div className='m-2 p-2'>
                                                <h1 className="subtitle is-4 is-light is-semibold is-spaced main-title is-justify-content-center is-flex ">{medicine?.Channeling}</h1>
                                                <div className='is-justify-content-space-between is-flex'>
                                                    <div>
                                                        {medicine?.StartDate}
                                                    </div>
                                                    <div>
                                                        {medicine?.Dosage}
                                                    </div>
                                                </div>
                                                <div className='is-justify-content-space-between is-flex'>
                                                    <div>
                                                        {medicine?.EndDate}
                                                    </div>
                                                    <div>
                                                        {medicine?.Frequency}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))) : (<div>No Medicine Found</div>)}

                    </div>
                </div>
            </div>
        </div>
      </div>
    </section>
  )
}

export default MedicinesFilterByChanneling